import Link from 'gatsby-link'
import * as React from 'react'

export interface INavigationTarget {
  active: boolean
  path: string
  text: string
}

interface INavigationProps {
  navigationTargets: INavigationTarget[]
}

class Navigation extends React.Component<INavigationProps, {}> {
  public componentDidMount(): void {
    $(document).ready(() => { $('.button-collapse').sideNav({ closeOnClick: true }) })
  }

  public linkElement(path: string, text: string, active: boolean): JSX.Element {
    const navigationText = <span className='nav-text'>{text}</span>
    if (path.indexOf('://') !== -1) {
      return <a href={path} target='_blank' className={active ? 'nav-active' : ''}>
        {navigationText}
      </a>
    }

    return <Link
      to={path}
      className={active ? 'nav-active' : ''}
    >
      {navigationText}
    </Link>
  }

  public navigationElements(navigationTargets: INavigationTarget[]): JSX.Element {
    if (navigationTargets && navigationTargets.length > 0) {
      return (
        <div>
          <a data-activates='mobile-sidebar' className='button-collapse'><i className='material-icons'>menu</i></a>
          <ul className='right hide-on-med-and-down'>
            {navigationTargets.map((object, i) => {
              return <li key={'nav-' + i}>{this.linkElement(object.path, object.text, object.active)}</li>
            })}
          </ul>
          <ul className='side-nav' id='mobile-sidebar'>
            {navigationTargets.map((object, i) => {
              return <li key={'nav' + i}>{this.linkElement(object.path, object.text, object.active)}</li>
            })}
          </ul>
        </div>
      )
    }
    else {
      return <div />
    }
  }

  public render(): JSX.Element {
    return <div className='navbar-friend'>
      <nav>
        {this.props.children}
        {this.navigationElements(this.props.navigationTargets)}
      </nav>
    </div>
  }
}

export default Navigation



// WEBPACK FOOTER //
// ./src/components/generic/Navigation.tsx